export default "__VITE_ASSET__Bx$Siljl__"